import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const CouFigureStyled = styled.figure`
  background-color: #dfe6e9;
  border-radius: 4px;
  margin: 0 auto 0.5rem;
  height: 200px;
  position: relative;
  width: 100%;
`;

const Image = styled.img`
  bottom: 0;
  display: block;
  height: auto;
  left: 0;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
`;

const Caption = styled.figcaption`
  background-color: rgba(255, 255, 255, 0.5);
  display: block;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  width: 100%;
`;

class CouFigure extends Component {
  render() {
    const { allowCaption, caption, quality, url, width } = this.props;

    const strippedUrl = url.replace(/^(https?:|)\/\//, '');
    const src = `//images.weserv.nl/?url=${strippedUrl}&w=${width}&q=${quality}&t=squaredown&output=jpg`;

    return (
      <CouFigureStyled>
        <Image src={src} alt={caption} />
        {allowCaption && caption && <Caption>{caption}</Caption>}
      </CouFigureStyled>
    );
  }
}

CouFigure.defaultProps = {
  allowCaption: true,
  caption: "",
  quality: 50,
  width: 1600
};

CouFigure.propTypes = {
  allowCaption: PropTypes.bool,
  caption: PropTypes.string,
  quality: PropTypes.number,
  url: PropTypes.string.isRequired,
  width: PropTypes.number
};

export default CouFigure;
